<template>
    <md-toolbar class="main-toolbar">
        <div v-if="project" class="md-toolbar-container">
            <md-button class="md-icon-button" @click="toggleLeftSidenav">
                <md-icon>menu</md-icon>
            </md-button>
            <h2 class="md-title">
                <span>{{project.title}}</span>
                <span class="project-version" v-if="currentVersion">{{currentVersion.name}}</span>
                <span class="project-version-live" v-else>Live Edit</span>
                <md-icon v-if="locked">lock</md-icon>
                <md-tooltip v-if="locked">This version is locked</md-tooltip>
            </h2>
            <img :src="require('../../assets/img/cuelist.png')" alt="cuelisttext" class="main-header-logo" />
            <project-search />
        </div>
        <div v-else class="md-toolbar-container">
            <md-button class="md-icon-button" @click="toggleLeftSidenav">
                <md-icon>menu</md-icon>
            </md-button>
            <div class="md-title">
                <md-avatar class="md-small">
                    <img :src="user.profile_picture" alt="People" v-if="user.profile_picture"/>
                    <img :src="require('../../assets/img/silhouette.jpg')" v-else alt="People"/>
                </md-avatar>
                <span class="avatar-name-role" v-if="user.username">{{user.username}}</span>
                <span class="avatar-name-role" v-else>Cuelist User</span>
            </div>
            <!-- <p>{{user.username}}</p> -->
            <img :src="require('../../assets/img/cuelistWHITE.png')" alt="cuelisttext" class="main-header-logo" />
        </div>
    </md-toolbar>
</template>

<script>
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import ProjectSearch from '@/components/project/search';

const CoreHeader = {
    name: 'CoreHeader',
    props: ['project', 'user', 'locked'],
    data: function() {
        return {
        };
    },
    computed: {
        ...mapGetters([
            'currentVersion'
        ])
    },
    methods: {
        toggleLeftSidenav() {
            NavBus.$emit('main-nav.open');
        }
    },
    components: {
        'project-search': ProjectSearch
    }
};
export default CoreHeader;

</script>

<style lang="scss">
.ql-project-search {
    position: absolute;
    max-width: 30%;
    right: 20px;
}

.project-version, .project-version-live {
    font-size: 17px;
    font-weight: bold;
    margin-left: 0.5rem;
}

.project-version-live {
    color: rgba(255, 255, 255, .54);
}

.project-version {
    color: #e91e63;
}

.md-toolbar {
    .md-toolbar-container {
        .md-title {
            flex: 1;
        }
        .main-header-logo {
            height: 42px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// header.vue?0bfe6ba3